import { render, staticRenderFns } from "./TongXunLu.vue?vue&type=template&id=2daedcd8&scoped=true"
import script from "./TongXunLu.vue?vue&type=script&lang=js"
export * from "./TongXunLu.vue?vue&type=script&lang=js"
import style0 from "./TongXunLu.vue?vue&type=style&index=0&id=2daedcd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daedcd8",
  null
  
)

export default component.exports